module.exports = __webpack_public_path__ + "media/demo_compressed.8ed81dc8.mp4";